<template>
<d-dialog
  :bar="bar"
  :disabled="disabled"
  :open="!!open"
  :window-width="width"
  class="c-dialog d-dialog"
  @on-click="onClick"
  @on-open="onOpen"
>
  <template v-slot:control="binds">
    <slot name="control" v-bind="binds"/>
  </template>
  <template v-slot:head>
    <div>
      <slot name="title"/>
    </div>
    <div class="c-dialog__spacer"/>
    <c-button
      appearance="text"
      class="c-dialog__close window-close"
      icon="close"
      palette="basic"
      size="small"
    />
  </template>
  <template v-slot:default>
    <slot/>
  </template>
</d-dialog>
</template>

<script>
import CButton from './CButton'
import DDialog from 'dcode/components/DDialog'

export default {
  name: 'CDialog',
  components: {
    CButton,
    DDialog
  },
  emits: ['on-click', 'on-open'],
  props: {
    // Status
    open: undefined,
    disabled: undefined,

    // Actions
    bar: undefined,

    // Options
    width: Number
  },
  setup (props, context) {
    return {
      onClick (event) {
        context.emit('on-click', event)
      },
      onOpen (event) {
        context.emit('on-open', event)
      }
    }
  }
}
</script>

<style lang="scss">
@import "~dcode/styles/font";
@import "~dcode/styles/media";

.c-dialog {
  --ac-padding: 16px;
  --dl-padding-y: 16px;
  --dl__hd-height: 0px;
  --ic-size: 16px;

  &__close {
    --ic-font: 28px;
  }

  &__spacer {
    flex-grow: 1;
  }

  .d-dialog {
    &__head {
      @include font('headline6');
      padding-top: 32px;
      padding-bottom: var(--ac-padding);
      align-items: center;

      @include mediaMinWidth {
        padding-top: 16px;
      }
    }
  }

  .d-actions {
    padding-top: var(--ac-padding);
    padding-bottom: 32px;

    @include mediaMinWidth {
      padding-bottom: 16px;
    }
  }
}
</style>
